import React, { useState, useEffect } from 'react';
import Comment from '../Comment/Comment';
import { useDispatch , useSelector} from 'react-redux';
//import moment from 'moment'
import "./_Comments.scss";
import { addComment, getCommentsOfVideoById } from '../../redux/actions/comments.action';


function Comments({videoId}) {

   const dispatch = useDispatch()

   useEffect(() => {
      dispatch(getCommentsOfVideoById(videoId))
   }, [videoId, dispatch])

   const comments = useSelector(state => state?.commentList?.comments)

   const _comments = comments?.map(
      comment => comment?.snippet?.topLevelComment?.snippet
   )
     
    const [text, setText] = useState('');



    const handleComment = e => {
        e.preventDefault()
        if (text.length === 0) return
  
        dispatch(addComment(videoId, text))
  
        setText('')
     }

    return (
        <div>
            <div className='comments'>
         <p>2806 Comments</p>
         <div className='my-2 comments__form d-flex w-100'>
            <img src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fmedia.syracuse.com%2Fbusiness-impact%2Fphoto%2FEric%2520Persons.JPG&f=1&nofb=1" alt='avatar' className='mr-3 rounded-circle' />
            <form onSubmit={handleComment} className='d-flex flex-grow-1'>
               <input
                  type='text'
                  className='flex-grow-1'
                  placeholder='Write a comment...'
                  value={text}
                  onChange={e => setText(e.target.value)}
               />
               <button className='p-2 border-0'>Comment</button>
            </form>
         </div>
         <div className='comments__list'>
               {_comments?.map((comment, i) => (
               <Comment comment={comment} key={i} 
               />
            ))}
         </div>
      </div>
            
    </div>
    )
}

export default Comments
